import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class GoalsDataTable {
  constructor() {
    $(document).ready(function() {
      showGoalsTable();
    });

    $(document).on("turbo:render", function() {
      showGoalsTable();
    });

    function showGoalsTable() {
      $('#goals-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#goals-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "goal_date"},
          {"data": "reason"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
